var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "carousel" }, [
      _c(
        "button",
        { staticClass: "nav-button left", on: { click: _vm.swipeToPrevious } },
        [_vm._v("<")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "carousel-container" },
        [
          _c(
            "transition",
            { attrs: { name: `carousel-${_vm.swipeDirection}` } },
            [
              _c(
                "div",
                { ref: "carousel", staticClass: "carousel__content" },
                [
                  _vm._t("default", null, {
                    currentIndex: _vm.currentImgIndex,
                  }),
                ],
                2
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "nav-button right", on: { click: _vm.swipeToNext } },
        [_vm._v(">")]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "indicators" },
      _vm._l(_vm.count, function (_, i) {
        return _c("span", {
          key: i,
          class: { active: i === _vm.currentImgIndex },
          on: {
            click: function ($event) {
              return _vm.goTo(i)
            },
          },
        })
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }